import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AdminView from "../views/AdminView.vue";
import LoginView from "../views/LoginView.vue";
import GeradorQr from "../views/GeradorQr.vue";
import PetPage from "../views/PetPage.vue";
import CompletarRegistroView from "../views/CompletarRegistroView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminView,
    meta: { requiresAuth: true },
  },
  {
    path: "/gerador-qr",
    name: "geradorQr",
    component: GeradorQr,
  },
  {
    path: "/consultar-pet/:codigo",
    name: "petDetalhe",
    component: PetPage,
  },
  {
    path: "/completar-registro/:token",
    name: "completarRegistro",
    component: CompletarRegistroView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requiresAuth) {
    const token = localStorage.getItem("ft_admin_token");
    if (!token) {
      next({ name: "login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
